const FETCH_ACCOUNT_INFO = 'FETCH_ACCOUNT_INFO';
const FETCH_ACCOUNT_SUCCESS = 'FETCH_ACCOUNT_SUCCESS';
const FETCH_ACCOUNT_FAILURE = 'FETCH_ACCOUNT_FAILURE';

export { FETCH_ACCOUNT_INFO, FETCH_ACCOUNT_SUCCESS, FETCH_ACCOUNT_FAILURE };
